import { render } from "./ResourceLinks.vue?vue&type=template&id=b24950ea"
import script from "./ResourceLinks.vue?vue&type=script&lang=js"
export * from "./ResourceLinks.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__